// for unassigment of employee
export const RESET_ADD_CUSTOMER_BANK_INFO = "resign_add_customer_bank_info";
export const ADD_CUSTOMER_BANK_INFO = "add_customer_bank_info";
export const ADD_CUSTOMER_BANK_INFO_SUCCESS = "add_customer_bank_info_success";
export const ADD_CUSTOMER_BANK_INFO_FAILURE = "add_customer_bank_info_failure";
